(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Scroll progress bar
  var bar = document.createElement('div');
  bar.className = 'm-progress';
  document.body.appendChild(bar);
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var y = h.scrollTop || window.scrollY || 0;
      bar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Staggered scroll reveals (skips elements the theme already reveals via .aos)
  var selectors = ['.pcard', 'main h1', 'main h2', 'main h3', '.accordion', '[data-motion]'];
  var els = Array.prototype.slice
    .call(document.querySelectorAll(selectors.join(',')))
    .filter(function (el) { return !el.classList.contains('aos'); });
  var groups = new Map();
  els.forEach(function (el) {
    el.classList.add('m-reveal');
    var p = el.parentElement;
    var i = groups.has(p) ? groups.get(p) : 0;
    el.style.setProperty('--mi', Math.min(i, 8));
    groups.set(p, i + 1);
  });
  if (els.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in-view');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.08 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  // Gentle parallax for [data-parallax] elements
  var pEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (pEls.length) {
    var pTick = false;
    var par = function () {
      if (pTick) return;
      pTick = true;
      requestAnimationFrame(function () {
        pEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var mid = r.top + r.height / 2 - window.innerHeight / 2;
          el.style.transform = 'translateY(' + (mid * -0.06).toFixed(1) + 'px)';
        });
        pTick = false;
      });
    };
    window.addEventListener('scroll', par, { passive: true });
    par();
  }

  // 3D tilt-toward-cursor on product cards
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var MAX = 6; // degrees
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest && e.target.closest('.pcard');
      if (!card) return;
      var media = card.querySelector('.pcard-media');
      if (!media) return;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      media.style.setProperty('--ry', (px * MAX).toFixed(2) + 'deg');
      media.style.setProperty('--rx', (py * -MAX).toFixed(2) + 'deg');
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.pcard');
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      var media = card.querySelector('.pcard-media');
      if (!media) return;
      media.style.setProperty('--rx', '0deg');
      media.style.setProperty('--ry', '0deg');
    }, { passive: true });
  }
})();
